import { RADIO_CONSTANTS } from './radio-constants';
var RadioFoundation = /** @class */ (function () {
    function RadioFoundation(_adapter) {
        this._adapter = _adapter;
        this._dense = false;
    }
    RadioFoundation.prototype.connect = function () {
        var _this = this;
        this._adapter.connect();
        this._focusListenerCallback = function () { return _this._adapter.syncFocusedStateWithInput(); };
        this._disabledListenerCallback = function () { return _this._adapter.syncDisabledStateWithInput(); };
        this._syncRadiogroupCheckStyles = function () { return _this._adapter.syncRadiogroupCheckStyles(); };
        this._addFocusEventListeners();
        this._addInputDisabledListener();
        this._extendNativeInputSetter();
        this._addRadioChangeListener();
        this._adapter.syncCheckedStateWithInput();
        this._adapter.syncDisabledStateWithInput();
        this._adapter.syncFocusedStateWithInput();
        this._applyDense();
        this.syncCheckedState();
    };
    RadioFoundation.prototype.disconnect = function () {
        this._removeFocusEventListeners();
        this._removeInputDisabledListener();
        this._adapter.revertNativeInputSetter();
        this._removeRadioChangeListener();
    };
    RadioFoundation.prototype.syncCheckedState = function () {
        this._adapter.syncCheckedStateWithInput();
    };
    RadioFoundation.prototype._applyDense = function () {
        if (this._dense) {
            this._adapter.addRootClass(RADIO_CONSTANTS.classes.RADIO_DENSE);
            this._adapter.setHostAttribute(RADIO_CONSTANTS.attributes.DENSE);
        }
        else {
            this._adapter.removeRootClass(RADIO_CONSTANTS.classes.RADIO_DENSE);
            this._adapter.removeHostAttribute(RADIO_CONSTANTS.attributes.DENSE);
        }
    };
    RadioFoundation.prototype._extendNativeInputSetter = function () {
        this._adapter.extendNativeInputSetter(this._syncRadiogroupCheckStyles);
    };
    RadioFoundation.prototype._addRadioChangeListener = function () {
        this._adapter.addInputEventListener('change', this._syncRadiogroupCheckStyles);
    };
    RadioFoundation.prototype._removeRadioChangeListener = function () {
        this._adapter.removeInputEventListener('change', this._syncRadiogroupCheckStyles);
    };
    RadioFoundation.prototype._addFocusEventListeners = function () {
        this._adapter.addInputEventListener('focus', this._focusListenerCallback);
        this._adapter.addInputEventListener('blur', this._focusListenerCallback);
    };
    RadioFoundation.prototype._removeFocusEventListeners = function () {
        this._adapter.removeInputEventListener('focus', this._focusListenerCallback);
        this._adapter.removeInputEventListener('blur', this._focusListenerCallback);
    };
    RadioFoundation.prototype._addInputDisabledListener = function () {
        this._adapter.addInputDisabledAttributeChangeListener(this._disabledListenerCallback);
    };
    RadioFoundation.prototype._removeInputDisabledListener = function () {
        this._adapter.removeInputDisabledAttributeChangeListener();
    };
    Object.defineProperty(RadioFoundation.prototype, "dense", {
        get: function () {
            return this._dense;
        },
        set: function (value) {
            if (this._dense !== value) {
                this._dense = value;
                this._applyDense();
            }
        },
        enumerable: true,
        configurable: true
    });
    return RadioFoundation;
}());
export { RadioFoundation };
